module.exports = __webpack_public_path__ + "bradavice_5_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/bradavice_5_after.jpg
// module id = 937
// module chunks = 0